module.exports = __webpack_public_path__ + "img/NewCarIcon.1649ac49.svg";